import { useNavigate } from "react-router";

const features = [
    {
        icon: "🏥",
        title: "OPD Management",
        desc: "Streamline outpatient visits with quick registration, doctor assignment, and visit history tracking.",
    },
    {
        icon: "🛏️",
        title: "IPD Management",
        desc: "Manage inpatient admissions, ward allocation, bed tracking, and discharge summaries effortlessly.",
    },
    {
        icon: "🧪",
        title: "Lab Reports",
        desc: "Generate, manage, and share diagnostic lab reports with custom templates and reference ranges.",
    },
    {
        icon: "📋",
        title: "Lab Templates",
        desc: "Build reusable report templates with unit-based and boolean tables for any test type.",
    },
    {
        icon: "👨‍⚕️",
        title: "Doctor Management",
        desc: "Maintain a complete roster of specialists, their schedules, and patient assignments.",
    },
    {
        icon: "💳",
        title: "Billing & Reporting",
        desc: "Accurate billing, payment tracking, and insightful reports to keep operations transparent.",
    },
];

const stats = [
    { value: "1", label: "Hospital live" },
    { value: "3+", label: "Departments" },
    { value: "100%", label: "Digital records" },
    { value: "24/7", label: "Access anytime" },
];

export default function Landing() {
    const navigate = useNavigate();

    return (
        <div
            style={{
                minHeight: "100vh",
                fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
                background: "#f0f4f8",
                color: "#1a2a3a",
            }}
        >
            {/* ─── NAVBAR ─── */}
            <nav
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 50,
                    background: "rgba(255,255,255,0.92)",
                    backdropFilter: "blur(12px)",
                    borderBottom: "1px solid rgba(0,180,160,0.12)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 2.5rem",
                    height: "64px",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: 10,
                            background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 16,
                        }}
                    >
                        M
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: 15, lineHeight: 1, color: "#0d2137" }}>
                            MyBioTick
                        </div>
                        <div style={{ fontSize: 11, color: "#6b8ca8", lineHeight: 1.3 }}>
                            Hospital Management
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    <a
                        href="/privacy-policy"
                        style={{
                            fontSize: 14,
                            color: "#4a6a80",
                            textDecoration: "none",
                            padding: "6px 14px",
                            borderRadius: 8,
                            transition: "background 0.2s",
                        }}
                    >
                        Privacy Policy
                    </a>
                    {/* <button
                        onClick={() => navigate("/login")}
                        style={{
                            padding: "8px 22px",
                            background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: "pointer",
                            boxShadow: "0 2px 12px rgba(0,119,204,0.25)",
                        }}
                    >
                        Sign In
                    </button> */}
                </div>
            </nav>

            {/* ─── HERO ─── */}
            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    padding: "100px 2.5rem 80px",
                    textAlign: "center",
                    background:
                        "linear-gradient(160deg, #e8f8f6 0%, #ddeeff 50%, #f0f4f8 100%)",
                }}
            >
                {/* Decorative blobs */}
                <div
                    style={{
                        position: "absolute",
                        top: -80,
                        left: -80,
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "radial-gradient(circle, rgba(0,180,160,0.12) 0%, transparent 70%)",
                        pointerEvents: "none",
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        bottom: -100,
                        right: -60,
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "radial-gradient(circle, rgba(0,119,204,0.10) 0%, transparent 70%)",
                        pointerEvents: "none",
                    }}
                />

                {/* Badge */}
                <div
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        background: "rgba(0,180,160,0.1)",
                        border: "1px solid rgba(0,180,160,0.3)",
                        borderRadius: 100,
                        padding: "6px 16px",
                        marginBottom: 28,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#007a70",
                    }}
                >
                    <span
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background: "#00b4a0",
                            display: "inline-block",
                            boxShadow: "0 0 0 3px rgba(0,180,160,0.25)",
                        }}
                    />
                    Now live at Haryana Multispeciality Hospital
                </div>

                <h1
                    style={{
                        fontSize: "clamp(2.2rem, 5vw, 3.6rem)",
                        fontWeight: 800,
                        lineHeight: 1.15,
                        color: "#0d2137",
                        marginBottom: 20,
                        maxWidth: 780,
                        margin: "0 auto 20px",
                        letterSpacing: "-0.02em",
                    }}
                >
                    Modern Hospital Management
                    <br />
                    <span
                        style={{
                            background: "linear-gradient(90deg, #00b4a0, #0077cc)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        Built for Real Healthcare
                    </span>
                </h1>

                <p
                    style={{
                        fontSize: "1.1rem",
                        color: "#4a6a80",
                        maxWidth: 580,
                        margin: "0 auto 40px",
                        lineHeight: 1.7,
                    }}
                >
                    MyBioTick is a comprehensive hospital management platform trusted by{" "}
                    <strong style={{ color: "#0d2137" }}>Haryana Multispeciality Hospital</strong> to
                    manage outpatient & inpatient departments, laboratory operations, billing, and
                    more — all in one secure system.
                </p>

                <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
                    {/* <button
                        onClick={() => navigate("/login")}
                        style={{
                            padding: "14px 32px",
                            background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                            color: "#fff",
                            border: "none",
                            borderRadius: 10,
                            fontWeight: 700,
                            fontSize: 15,
                            cursor: "pointer",
                            boxShadow: "0 4px 20px rgba(0,119,204,0.3)",
                            letterSpacing: "0.01em",
                        }}
                    >
                        Get Started →
                    </button> */}
                    <a
                        href="/privacy-policy"
                        style={{
                            padding: "14px 32px",
                            background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                            color: "#fff",
                            border: "none",
                            borderRadius: 10,
                            fontWeight: 700,
                            fontSize: 15,
                            cursor: "pointer",
                            boxShadow: "0 4px 20px rgba(0,119,204,0.3)",
                            letterSpacing: "0.01em",
                        }}
                    >
                        Privacy Policy
                    </a>
                </div>
            </section>

            {/* ─── STATS BANNER ─── */}
            <section
                style={{
                    background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                    padding: "48px 2.5rem",
                }}
            >
                <div
                    style={{
                        maxWidth: 960,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                        gap: 32,
                        textAlign: "center",
                    }}
                >
                    {stats.map((s) => (
                        <div key={s.label}>
                            <div
                                style={{
                                    fontSize: "2.5rem",
                                    fontWeight: 800,
                                    color: "#fff",
                                    lineHeight: 1,
                                    marginBottom: 6,
                                }}
                            >
                                {s.value}
                            </div>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "rgba(255,255,255,0.75)",
                                    fontWeight: 500,
                                }}
                            >
                                {s.label}
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ─── FEATURES ─── */}
            <section style={{ padding: "80px 2.5rem", maxWidth: 1100, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 56 }}>
                    <p
                        style={{
                            fontSize: 12,
                            fontWeight: 700,
                            letterSpacing: "0.12em",
                            color: "#00b4a0",
                            textTransform: "uppercase",
                            marginBottom: 10,
                        }}
                    >
                        Platform Capabilities
                    </p>
                    <h2
                        style={{
                            fontSize: "clamp(1.8rem, 3vw, 2.5rem)",
                            fontWeight: 800,
                            color: "#0d2137",
                            marginBottom: 16,
                            letterSpacing: "-0.02em",
                        }}
                    >
                        Everything your hospital needs
                    </h2>
                    <p style={{ color: "#4a6a80", fontSize: "1rem", maxWidth: 480, margin: "0 auto" }}>
                        From the front desk to the lab, every workflow is covered in one unified system.
                    </p>
                </div>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: 20,
                    }}
                >
                    {features.map((f) => (
                        <div
                            key={f.title}
                            style={{
                                background: "#fff",
                                borderRadius: 16,
                                padding: "28px 28px",
                                border: "1px solid rgba(0,0,0,0.07)",
                                transition: "box-shadow 0.2s, transform 0.2s",
                                cursor: "default",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,119,204,0.12)";
                                e.currentTarget.style.transform = "translateY(-2px)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = "none";
                                e.currentTarget.style.transform = "translateY(0)";
                            }}
                        >
                            <div style={{ fontSize: 32, marginBottom: 14 }}>{f.icon}</div>
                            <h3
                                style={{
                                    fontSize: 17,
                                    fontWeight: 700,
                                    color: "#0d2137",
                                    marginBottom: 8,
                                }}
                            >
                                {f.title}
                            </h3>
                            <p style={{ fontSize: 14, color: "#5a7a90", lineHeight: 1.65 }}>{f.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ─── HOSPITAL SPOTLIGHT ─── */}
            <section
                style={{
                    background: "#fff",
                    borderTop: "1px solid rgba(0,0,0,0.06)",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    padding: "80px 2.5rem",
                }}
            >
                <div
                    style={{
                        maxWidth: 960,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 60,
                        alignItems: "center",
                    }}
                >
                    <div>
                        <p
                            style={{
                                fontSize: 12,
                                fontWeight: 700,
                                letterSpacing: "0.12em",
                                color: "#00b4a0",
                                textTransform: "uppercase",
                                marginBottom: 10,
                            }}
                        >
                            Live Implementation
                        </p>
                        <h2
                            style={{
                                fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)",
                                fontWeight: 800,
                                color: "#0d2137",
                                marginBottom: 18,
                                letterSpacing: "-0.02em",
                                lineHeight: 1.2,
                            }}
                        >
                            Trusted by Haryana
                            <br />
                            Multispeciality Hospital
                        </h2>
                        <p style={{ color: "#4a6a80", fontSize: "0.95rem", lineHeight: 1.75, marginBottom: 24 }}>
                            MyBioTick has been successfully deployed at Haryana Multispeciality Hospital,
                            transforming how they handle patient records, lab diagnostics, and day-to-day
                            administrative workflows. The platform handles OPD registrations, IPD admissions,
                            lab reports, and doctor management with ease.
                        </p>
                        <div
                            style={{
                                background: "linear-gradient(135deg, #e8f8f6 0%, #ddeeff 100%)",
                                borderRadius: 12,
                                padding: "16px 20px",
                                borderLeft: "3px solid #00b4a0",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: 600,
                                    color: "#0d2137",
                                    marginBottom: 4,
                                }}
                            >
                                🚀 Coming Soon
                            </p>
                            <p style={{ fontSize: 13, color: "#4a6a80", lineHeight: 1.6 }}>
                                Integration with additional branches of Haryana Multispeciality Hospital is
                                actively in progress — bringing unified management across all locations.
                            </p>
                        </div>
                    </div>

                    <div
                        style={{
                            background: "linear-gradient(135deg, #e8f8f6 0%, #ddeeff 100%)",
                            borderRadius: 20,
                            padding: "32px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 14,
                        }}
                    >
                        {[
                            { icon: "✅", text: "OPD & IPD visits fully digitised" },
                            { icon: "✅", text: "Custom lab templates per test" },
                            { icon: "✅", text: "Doctor-patient assignment tracking" },
                            { icon: "✅", text: "Ward & bed management" },
                            { icon: "✅", text: "Billing & financial reporting" },
                            { icon: "🔜", text: "Multi-branch rollout underway" },
                        ].map((item) => (
                            <div
                                key={item.text}
                                style={{ display: "flex", alignItems: "center", gap: 12 }}
                            >
                                <span style={{ fontSize: 16 }}>{item.icon}</span>
                                <span style={{ fontSize: 14, color: "#2a4a60", fontWeight: 500 }}>
                                    {item.text}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ─── CTA ─── */}
            <section
                style={{
                    padding: "80px 2.5rem",
                    textAlign: "center",
                    background: "linear-gradient(160deg, #ddeeff 0%, #e8f8f6 100%)",
                }}
            >
                <h2
                    style={{
                        fontSize: "clamp(1.8rem, 3vw, 2.4rem)",
                        fontWeight: 800,
                        color: "#0d2137",
                        marginBottom: 16,
                        letterSpacing: "-0.02em",
                    }}
                >
                    Ready to modernise your hospital?
                </h2>
                {/* <p style={{ color: "#4a6a80", fontSize: "1rem", marginBottom: 36, maxWidth: 460, margin: "0 auto 36px" }}>
                    Sign in to your MyBioTick dashboard and manage your entire hospital from one place.
                </p>
                <button
                    onClick={() => navigate("/login")}
                    style={{
                        padding: "16px 40px",
                        background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                        color: "#fff",
                        border: "none",
                        borderRadius: 12,
                        fontWeight: 700,
                        fontSize: 16,
                        cursor: "pointer",
                        boxShadow: "0 4px 24px rgba(0,119,204,0.3)",
                        letterSpacing: "0.01em",
                    }}
                >
                    Sign In to Dashboard →
                </button> */}
            </section>

            {/* ─── FOOTER ─── */}
            <footer
                style={{
                    background: "#0d2137",
                    color: "rgba(255,255,255,0.6)",
                    padding: "32px 2.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 12,
                    fontSize: 13,
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div
                        style={{
                            width: 28,
                            height: 28,
                            borderRadius: 8,
                            background: "linear-gradient(135deg, #00b4a0 0%, #0077cc 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 13,
                        }}
                    >
                        M
                    </div>
                    <span style={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}>MyBioTick</span>
                    <span>— Hospital Management System</span>
                </div>
                <div style={{ display: "flex", gap: 20 }}>
                    <a href="/privacy-policy" style={{ color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>
                        Privacy Policy
                    </a>
                    <span>© 2026 MyBioTick. All rights reserved.</span>
                </div>
            </footer>
        </div>
    );
}